import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

const featuredMovies = movies.filter((m) => m.isHot);

export default function FeaturedSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="container-site">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网最受欢迎的影片，大家都在看</p>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1 cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {featuredMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}